import { render } from "./DashboardCards.vue?vue&type=template&id=64fead62"
import script from "./DashboardCards.vue?vue&type=script&lang=js"
export * from "./DashboardCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__